import { PDFDownloadLink } from '@react-pdf/renderer';
import styled from 'styled-components';
import { BodyBoldM, BodyBoldS } from '../../styles/globals';
import CommuniqLogo from '@/assets/icons/communiq-logo-grey.svg?react';

export const Header = styled.header`
  ${({ theme }) => `
    display: flex;
    width: 100%;
    padding: ${theme.layout.spacing.centy} ${theme.layout.spacing.deka};
    align-items: center;
    background: ${theme.colors.primary[100]};

    @media ${theme.layout.breakpoints.max.tablet} {
      flex-flow: column nowrap;
      padding: ${theme.layout.spacing.centy};
    }
  `}
`;

export const Logo = styled(CommuniqLogo)`
  ${({ theme }) => `
    width: 5rem;
    height: 5rem;
  
    @media ${theme.layout.breakpoints.max.tablet} {
      margin: 0 0 ${theme.layout.spacing.centy};
    }
  `};
`;

export const ContentCont = styled.div`
  ${({ theme }) => `
    display: flex;
    padding: 0 ${theme.layout.spacing.deka};
    flex: 2;
    flex-flow: column nowrap;
    justify-content: center;

    @media ${theme.layout.breakpoints.max.tablet} {
      margin: 0 0 ${theme.layout.spacing.centy};
    }
  `}
`;

export const ActionsCont = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
`;

export const Heading = styled(BodyBoldM)`
  ${({ theme }) => `
    margin: 0 0 ${theme.layout.spacing.nano};
    color: ${theme.colors.neutral.primary[0]};

    @media ${theme.layout.breakpoints.max.tablet} {
      font-size: 20px;
      line-height: 23px;
      text-align: center;
    }
  `}
`;

export const SubHeading = styled(BodyBoldS)`
  ${({ theme }) => `
    margin: 0;
    color: ${theme.colors.neutral.primary[0]};

    @media ${theme.layout.breakpoints.max.tablet} {
      font-size: 14px;
      line-height: 16px;
      text-align: center;
    }
  `}
`;

export const DownloadLink = styled(PDFDownloadLink)`
  ${({ theme }) => `
    display: flex;
    max-width: 140px;
    width: 100%;
    height: 42px;
    margin: 0 ${theme.layout.spacing.centy} 0 0;
    padding: ${theme.layout.spacing.mikro} ${theme.layout.spacing.centy};
    align-items: center;
    justify-content: center;
    background: ${theme.colors.neutral.primary[5]};
    border-radius: 4px;
    color: ${theme.colors.primary[100]};
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    transition: all 0.2s ease-in-out;

    &:hover {
      background: ${theme.colors.neutral.primary[0]};
      color: ${theme.colors.primary[100]};
    }
  `}
`;

export const ChangeLangCont = styled.div`
  position: relative;
`;

export const Main = styled.main`
  ${({ theme }) => `
    display: flex;
    padding: ${theme.layout.spacing.deka} ${theme.layout.spacing.deka} ${theme.layout.spacing.hekto};
    justify-content: center;

    @media ${theme.layout.breakpoints.max.tablet} {
      padding: ${theme.layout.spacing.deka} ${theme.layout.spacing.mili};
    }
  `};
`;

export const MainCont = styled.div`
  display: flex;
  max-width: 72.5rem;
  width: 100%;
  flex-flow: column nowrap;
`;

export const SpinnerCont = styled.div`
  position: fixed;
  z-index: 1;
  top: 50%;
  left: 50%;

  .ant-spin-dot {
    font-size: 3.75rem;

    .ant-spin-dot-item {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
`;
